"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProtectedTeamServiceServer = exports.ProtectedTeamServiceDispatcher = exports.ProtectedTeamServiceClient = void 0;
var TeamIdWithTemplateId_1 = require("./TeamIdWithTemplateId");
var RankChangeFailure_1 = require("./RankChangeFailure");
var JoinResult_1 = require("./JoinResult");
var services_shared_1 = require("@playq/services-shared");
var RecruitmentFailure_1 = require("./RecruitmentFailure");
var KickFailure_1 = require("./KickFailure");
var InviteData_1 = require("./InviteData");
var DenyFailure_1 = require("./DenyFailure");
var InviteId_1 = require("./InviteId");
var JoinRequestData_1 = require("./JoinRequestData");
var TeamMemberData_1 = require("./TeamMemberData");
var SelfPromoteFailure_1 = require("./SelfPromoteFailure");
var irt_1 = require("@playq/irt");
var InJoin = (function () {
    function InJoin(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.ids = new TeamIdWithTemplateId_1.TeamIdWithTemplateId(data.ids);
        this.joinRequest = JoinRequestData_1.JoinRequestDataStruct.create(data.joinRequest);
    }
    Object.defineProperty(InJoin.prototype, "ids", {
        get: function () {
            return this._ids;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field ids is not optional');
            }
            this._ids = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InJoin.prototype, "joinRequest", {
        get: function () {
            return this._joinRequest;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field joinRequest is not optional');
            }
            this._joinRequest = value;
        },
        enumerable: false,
        configurable: true
    });
    InJoin.prototype.serialize = function () {
        var _a;
        return {
            ids: this.ids.serialize(),
            joinRequest: (_a = {}, _a[this.joinRequest.getFullClassName()] = this.joinRequest.serialize(), _a)
        };
    };
    return InJoin;
}());
var OutJoinHelpers = (function () {
    function OutJoinHelpers() {
    }
    OutJoinHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': RecruitmentFailure_1.RecruitmentFailureHelpers.serialize(either.value)
        };
    };
    OutJoinHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new JoinResult_1.JoinResult(content));
            case 'Failure': return new irt_1.Left(RecruitmentFailure_1.RecruitmentFailureHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutJoinHelpers;
}());
var InLeave = (function () {
    function InLeave(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.ids = new TeamIdWithTemplateId_1.TeamIdWithTemplateId(data.ids);
    }
    Object.defineProperty(InLeave.prototype, "ids", {
        get: function () {
            return this._ids;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field ids is not optional');
            }
            this._ids = value;
        },
        enumerable: false,
        configurable: true
    });
    InLeave.prototype.serialize = function () {
        return {
            ids: this.ids.serialize()
        };
    };
    return InLeave;
}());
var OutLeaveHelpers = (function () {
    function OutLeaveHelpers() {
    }
    OutLeaveHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutLeaveHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutLeaveHelpers;
}());
var InInvite = (function () {
    function InInvite(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.inviteData = new InviteData_1.InviteData(data.inviteData);
    }
    Object.defineProperty(InInvite.prototype, "inviteData", {
        get: function () {
            return this._inviteData;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field inviteData is not optional');
            }
            this._inviteData = value;
        },
        enumerable: false,
        configurable: true
    });
    InInvite.prototype.serialize = function () {
        return {
            inviteData: this.inviteData.serialize()
        };
    };
    return InInvite;
}());
var OutInviteHelpers = (function () {
    function OutInviteHelpers() {
    }
    OutInviteHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': RecruitmentFailure_1.RecruitmentFailureHelpers.serialize(either.value)
        };
    };
    OutInviteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(RecruitmentFailure_1.RecruitmentFailureHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutInviteHelpers;
}());
var InRejectInvite = (function () {
    function InRejectInvite(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new InviteId_1.InviteId(data.id);
    }
    Object.defineProperty(InRejectInvite.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InRejectInvite.prototype.serialize = function () {
        return {
            id: this.id.serialize()
        };
    };
    return InRejectInvite;
}());
var OutRejectInviteHelpers = (function () {
    function OutRejectInviteHelpers() {
    }
    OutRejectInviteHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': RecruitmentFailure_1.RecruitmentFailureHelpers.serialize(either.value)
        };
    };
    OutRejectInviteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(RecruitmentFailure_1.RecruitmentFailureHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRejectInviteHelpers;
}());
var InKick = (function () {
    function InKick(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.teamId = new services_shared_1.TeamId(data.teamId);
        this.userId = new services_shared_1.UserId(data.userId);
    }
    Object.defineProperty(InKick.prototype, "teamId", {
        get: function () {
            return this._teamId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamId is not optional');
            }
            this._teamId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InKick.prototype, "userId", {
        get: function () {
            return this._userId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field userId is not optional');
            }
            this._userId = value;
        },
        enumerable: false,
        configurable: true
    });
    InKick.prototype.serialize = function () {
        return {
            teamId: this.teamId.serialize(),
            userId: this.userId.serialize()
        };
    };
    return InKick;
}());
var OutKickHelpers = (function () {
    function OutKickHelpers() {
    }
    OutKickHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': KickFailure_1.KickFailureHelpers.serialize(either.value)
        };
    };
    OutKickHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(KickFailure_1.KickFailureHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutKickHelpers;
}());
var InKickList = (function () {
    function InKickList(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.teamId = new services_shared_1.TeamId(data.teamId);
        this.users = data.users.map(function (e) { return new services_shared_1.UserId(e); });
    }
    Object.defineProperty(InKickList.prototype, "teamId", {
        get: function () {
            return this._teamId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamId is not optional');
            }
            this._teamId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InKickList.prototype, "users", {
        get: function () {
            return this._users;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field users is not optional');
            }
            this._users = value;
        },
        enumerable: false,
        configurable: true
    });
    InKickList.prototype.serialize = function () {
        return {
            teamId: this.teamId.serialize(),
            users: this.users.map(function (e) { return e.serialize(); })
        };
    };
    return InKickList;
}());
var OutKickListHelpers = (function () {
    function OutKickListHelpers() {
    }
    OutKickListHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': KickFailure_1.KickFailureHelpers.serialize(either.value)
        };
    };
    OutKickListHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(KickFailure_1.KickFailureHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutKickListHelpers;
}());
var InAccept = (function () {
    function InAccept(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.teamId = new services_shared_1.TeamId(data.teamId);
        this.userId = new services_shared_1.UserId(data.userId);
    }
    Object.defineProperty(InAccept.prototype, "teamId", {
        get: function () {
            return this._teamId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamId is not optional');
            }
            this._teamId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InAccept.prototype, "userId", {
        get: function () {
            return this._userId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field userId is not optional');
            }
            this._userId = value;
        },
        enumerable: false,
        configurable: true
    });
    InAccept.prototype.serialize = function () {
        return {
            teamId: this.teamId.serialize(),
            userId: this.userId.serialize()
        };
    };
    return InAccept;
}());
var OutAcceptHelpers = (function () {
    function OutAcceptHelpers() {
    }
    OutAcceptHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': RecruitmentFailure_1.RecruitmentFailureHelpers.serialize(either.value)
        };
    };
    OutAcceptHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(RecruitmentFailure_1.RecruitmentFailureHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutAcceptHelpers;
}());
var InDeny = (function () {
    function InDeny(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.teamId = new services_shared_1.TeamId(data.teamId);
        this.userId = new services_shared_1.UserId(data.userId);
    }
    Object.defineProperty(InDeny.prototype, "teamId", {
        get: function () {
            return this._teamId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamId is not optional');
            }
            this._teamId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeny.prototype, "userId", {
        get: function () {
            return this._userId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field userId is not optional');
            }
            this._userId = value;
        },
        enumerable: false,
        configurable: true
    });
    InDeny.prototype.serialize = function () {
        return {
            teamId: this.teamId.serialize(),
            userId: this.userId.serialize()
        };
    };
    return InDeny;
}());
var OutDenyHelpers = (function () {
    function OutDenyHelpers() {
    }
    OutDenyHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': DenyFailure_1.DenyFailureHelpers.serialize(either.value)
        };
    };
    OutDenyHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(DenyFailure_1.DenyFailureHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDenyHelpers;
}());
var InPromote = (function () {
    function InPromote(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.teamId = new services_shared_1.TeamId(data.teamId);
        this.userId = new services_shared_1.UserId(data.userId);
    }
    Object.defineProperty(InPromote.prototype, "teamId", {
        get: function () {
            return this._teamId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamId is not optional');
            }
            this._teamId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InPromote.prototype, "userId", {
        get: function () {
            return this._userId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field userId is not optional');
            }
            this._userId = value;
        },
        enumerable: false,
        configurable: true
    });
    InPromote.prototype.serialize = function () {
        return {
            teamId: this.teamId.serialize(),
            userId: this.userId.serialize()
        };
    };
    return InPromote;
}());
var OutPromoteHelpers = (function () {
    function OutPromoteHelpers() {
    }
    OutPromoteHelpers.serialize = function (either) {
        var _a;
        return either.isRight() ? {
            'Success': (_a = {}, _a[either.value.getFullClassName()] = either.value.serialize(), _a)
        } : {
            'Failure': RankChangeFailure_1.RankChangeFailureHelpers.serialize(either.value)
        };
    };
    OutPromoteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(TeamMemberData_1.TeamMemberDataStruct.create(content));
            case 'Failure': return new irt_1.Left(RankChangeFailure_1.RankChangeFailureHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutPromoteHelpers;
}());
var InDemote = (function () {
    function InDemote(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.teamId = new services_shared_1.TeamId(data.teamId);
        this.userId = new services_shared_1.UserId(data.userId);
    }
    Object.defineProperty(InDemote.prototype, "teamId", {
        get: function () {
            return this._teamId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamId is not optional');
            }
            this._teamId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDemote.prototype, "userId", {
        get: function () {
            return this._userId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field userId is not optional');
            }
            this._userId = value;
        },
        enumerable: false,
        configurable: true
    });
    InDemote.prototype.serialize = function () {
        return {
            teamId: this.teamId.serialize(),
            userId: this.userId.serialize()
        };
    };
    return InDemote;
}());
var OutDemoteHelpers = (function () {
    function OutDemoteHelpers() {
    }
    OutDemoteHelpers.serialize = function (either) {
        var _a;
        return either.isRight() ? {
            'Success': (_a = {}, _a[either.value.getFullClassName()] = either.value.serialize(), _a)
        } : {
            'Failure': RankChangeFailure_1.RankChangeFailureHelpers.serialize(either.value)
        };
    };
    OutDemoteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(TeamMemberData_1.TeamMemberDataStruct.create(content));
            case 'Failure': return new irt_1.Left(RankChangeFailure_1.RankChangeFailureHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDemoteHelpers;
}());
var InSelfPromote = (function () {
    function InSelfPromote(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.teamId = new services_shared_1.TeamId(data.teamId);
    }
    Object.defineProperty(InSelfPromote.prototype, "teamId", {
        get: function () {
            return this._teamId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamId is not optional');
            }
            this._teamId = value;
        },
        enumerable: false,
        configurable: true
    });
    InSelfPromote.prototype.serialize = function () {
        return {
            teamId: this.teamId.serialize()
        };
    };
    return InSelfPromote;
}());
var OutSelfPromoteHelpers = (function () {
    function OutSelfPromoteHelpers() {
    }
    OutSelfPromoteHelpers.serialize = function (either) {
        var _a;
        return either.isRight() ? {
            'Success': (_a = {}, _a[either.value.getFullClassName()] = either.value.serialize(), _a)
        } : {
            'Failure': SelfPromoteFailure_1.SelfPromoteFailureHelpers.serialize(either.value)
        };
    };
    OutSelfPromoteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(TeamMemberData_1.TeamMemberDataStruct.create(content));
            case 'Failure': return new irt_1.Left(SelfPromoteFailure_1.SelfPromoteFailureHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutSelfPromoteHelpers;
}());
var ProtectedTeamServiceClient = (function () {
    function ProtectedTeamServiceClient(transport) {
        this._transport = transport;
    }
    ProtectedTeamServiceClient.prototype.getPackageName = function () { return ProtectedTeamServiceClient.PackageName; };
    ProtectedTeamServiceClient.prototype.getClassName = function () { return ProtectedTeamServiceClient.ClassName; };
    ProtectedTeamServiceClient.prototype.getFullClassName = function () { return ProtectedTeamServiceClient.FullClassName; };
    ProtectedTeamServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamServiceClient.prototype.join = function (ids, joinRequest) {
        var _this = this;
        var __data = new InJoin();
        __data.ids = ids;
        __data.joinRequest = joinRequest;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamServiceClient.ClassName, 'join', __data)
                .then(function (data) {
                try {
                    resolve(OutJoinHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamServiceClient.prototype.leave = function (ids) {
        var _this = this;
        var __data = new InLeave();
        __data.ids = ids;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamServiceClient.ClassName, 'leave', __data)
                .then(function (data) {
                try {
                    resolve(OutLeaveHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamServiceClient.prototype.invite = function (inviteData) {
        var _this = this;
        var __data = new InInvite();
        __data.inviteData = inviteData;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamServiceClient.ClassName, 'invite', __data)
                .then(function (data) {
                try {
                    resolve(OutInviteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamServiceClient.prototype.rejectInvite = function (id) {
        var _this = this;
        var __data = new InRejectInvite();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamServiceClient.ClassName, 'rejectInvite', __data)
                .then(function (data) {
                try {
                    resolve(OutRejectInviteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamServiceClient.prototype.kick = function (teamId, userId) {
        var _this = this;
        var __data = new InKick();
        __data.teamId = teamId;
        __data.userId = userId;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamServiceClient.ClassName, 'kick', __data)
                .then(function (data) {
                try {
                    resolve(OutKickHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamServiceClient.prototype.kickList = function (teamId, users) {
        var _this = this;
        var __data = new InKickList();
        __data.teamId = teamId;
        __data.users = users;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamServiceClient.ClassName, 'kickList', __data)
                .then(function (data) {
                try {
                    resolve(OutKickListHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamServiceClient.prototype.accept = function (teamId, userId) {
        var _this = this;
        var __data = new InAccept();
        __data.teamId = teamId;
        __data.userId = userId;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamServiceClient.ClassName, 'accept', __data)
                .then(function (data) {
                try {
                    resolve(OutAcceptHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamServiceClient.prototype.deny = function (teamId, userId) {
        var _this = this;
        var __data = new InDeny();
        __data.teamId = teamId;
        __data.userId = userId;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamServiceClient.ClassName, 'deny', __data)
                .then(function (data) {
                try {
                    resolve(OutDenyHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamServiceClient.prototype.promote = function (teamId, userId) {
        var _this = this;
        var __data = new InPromote();
        __data.teamId = teamId;
        __data.userId = userId;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamServiceClient.ClassName, 'promote', __data)
                .then(function (data) {
                try {
                    resolve(OutPromoteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamServiceClient.prototype.demote = function (teamId, userId) {
        var _this = this;
        var __data = new InDemote();
        __data.teamId = teamId;
        __data.userId = userId;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamServiceClient.ClassName, 'demote', __data)
                .then(function (data) {
                try {
                    resolve(OutDemoteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamServiceClient.prototype.selfPromote = function (teamId) {
        var _this = this;
        var __data = new InSelfPromote();
        __data.teamId = teamId;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamServiceClient.ClassName, 'selfPromote', __data)
                .then(function (data) {
                try {
                    resolve(OutSelfPromoteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamServiceClient.PackageName = 'net.playq.services.teams';
    ProtectedTeamServiceClient.ClassName = 'ProtectedTeamService';
    ProtectedTeamServiceClient.FullClassName = 'net.playq.services.teams.ProtectedTeamService';
    return ProtectedTeamServiceClient;
}());
exports.ProtectedTeamServiceClient = ProtectedTeamServiceClient;
var ProtectedTeamServiceDispatcher = (function () {
    function ProtectedTeamServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    ProtectedTeamServiceDispatcher.prototype.getSupportedService = function () {
        return 'ProtectedTeamService';
    };
    ProtectedTeamServiceDispatcher.prototype.getSupportedMethods = function () {
        return ProtectedTeamServiceDispatcher.methods;
    };
    ProtectedTeamServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "join": {
                var obj_1 = new InJoin(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.join(context, obj_1.ids, obj_1.joinRequest)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutJoinHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "leave": {
                var obj_2 = new InLeave(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.leave(context, obj_2.ids)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutLeaveHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "invite": {
                var obj_3 = new InInvite(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.invite(context, obj_3.inviteData)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutInviteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "rejectInvite": {
                var obj_4 = new InRejectInvite(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.rejectInvite(context, obj_4.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRejectInviteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "kick": {
                var obj_5 = new InKick(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.kick(context, obj_5.teamId, obj_5.userId)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutKickHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "kickList": {
                var obj_6 = new InKickList(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.kickList(context, obj_6.teamId, obj_6.users)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutKickListHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "accept": {
                var obj_7 = new InAccept(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.accept(context, obj_7.teamId, obj_7.userId)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutAcceptHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "deny": {
                var obj_8 = new InDeny(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.deny(context, obj_8.teamId, obj_8.userId)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDenyHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "promote": {
                var obj_9 = new InPromote(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.promote(context, obj_9.teamId, obj_9.userId)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutPromoteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "demote": {
                var obj_10 = new InDemote(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.demote(context, obj_10.teamId, obj_10.userId)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDemoteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "selfPromote": {
                var obj_11 = new InSelfPromote(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.selfPromote(context, obj_11.teamId)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutSelfPromoteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by ProtectedTeamServiceDispatcher."));
        }
    };
    ProtectedTeamServiceDispatcher.methods = [
        "join",
        "leave",
        "invite",
        "rejectInvite",
        "kick",
        "kickList",
        "accept",
        "deny",
        "promote",
        "demote",
        "selfPromote"
    ];
    return ProtectedTeamServiceDispatcher;
}());
exports.ProtectedTeamServiceDispatcher = ProtectedTeamServiceDispatcher;
var ProtectedTeamServiceServer = (function (_super) {
    __extends(ProtectedTeamServiceServer, _super);
    function ProtectedTeamServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    ProtectedTeamServiceServer.prototype.join = function (context, ids, joinRequest) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamServiceServer.prototype.leave = function (context, ids) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamServiceServer.prototype.invite = function (context, inviteData) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamServiceServer.prototype.rejectInvite = function (context, id) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamServiceServer.prototype.kick = function (context, teamId, userId) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamServiceServer.prototype.kickList = function (context, teamId, users) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamServiceServer.prototype.accept = function (context, teamId, userId) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamServiceServer.prototype.deny = function (context, teamId, userId) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamServiceServer.prototype.promote = function (context, teamId, userId) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamServiceServer.prototype.demote = function (context, teamId, userId) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamServiceServer.prototype.selfPromote = function (context, teamId) {
        throw new Error('Not implemented.');
    };
    return ProtectedTeamServiceServer;
}(ProtectedTeamServiceDispatcher));
exports.ProtectedTeamServiceServer = ProtectedTeamServiceServer;
//# sourceMappingURL=ProtectedTeamService.js.map